import { Injectable, signal } from '@angular/core'

export interface DocumentViewerState {
  blobUrl: string | null
  mimeType: string | null
  filename: string
  loading: boolean
  error: boolean
  downloadFn?: () => void
}

@Injectable({ providedIn: 'root' })
export class DocumentViewerService {
  readonly state = signal<DocumentViewerState | null>(null)

  open(initial: Omit<DocumentViewerState, 'blobUrl' | 'error'>): void {
    this.state.set({ blobUrl: null, error: false, ...initial })
  }

  triggerDownload(): void {
    this.state()?.downloadFn?.()
  }

  update(patch: Partial<DocumentViewerState>): void {
    const current = this.state()
    if (current) this.state.set({ ...current, ...patch })
  }

  close(): void {
    const current = this.state()
    if (current?.blobUrl) URL.revokeObjectURL(current.blobUrl)
    this.state.set(null)
  }
}
